import React from 'react';

const InputFeedback = ({ error }) =>
  error ? (
    <div className="input-feedback-template">{error}</div>
  ) : null;

export default InputFeedback;



// WEBPACK FOOTER //
// ./src/components/InputFeedback.js